import jsPDF from "jspdf";
/**
 * Documento jsPDF com configurações de estilo
 */
export default class docJSPDF {
    constructor(theme, footerTopo = false, useCellPadding = false) {
        this.marginTopPage = 15; // Espaço entre início da página e topo
        this.MIN_TABLE_SPACE = 35; // valor para deixar a tabela com pelo menos 3 elementos
        this.MARGIN_LEFT_RIGHT = 5; // valor default para margin das tabelas da biblioteca autoTable
        this.MARGIN_TABLE = 10; // valor default para margin das tabelas da biblioteca autoTable
        this.MARGIN_FOOTER_TOP = 8; // aumenta spacing-top caso o footer esteja no topo da página
        this.FOOTER_SIZE = 12; // tamanho do footer
        this.theme = theme;
        this.doc = new jsPDF();
        this.width = this.doc.internal.pageSize.getWidth() - 2 * this.MARGIN_LEFT_RIGHT;
        this.heightPDF = this.doc.internal.pageSize.getHeight() - 2 * this.MARGIN_TABLE;
        this.footerTopo = footerTopo;
        if (this.footerTopo) {
            this.marginTopPage += this.MARGIN_FOOTER_TOP; // aumenta o espaço entre o ínicio da página do PDF e os elementos para caber o footer no topo
        }
        this.marginBottomTable = this.theme.marginBottomTablePDF;
        docJSPDF.styleTableBody.fontSize = this.theme.xsFontSizePDF;
        if (useCellPadding) {
            docJSPDF.styleTableBody.cellPadding = {
                horizontal: this.theme.cellPaddingHorizontalTablePDF,
                vertical: this.theme.cellPaddingVerticalTablePDF,
            };
        }
    }
    /**
     * Gera o título das páginas com seus estilos
     * @param text Título da página
     * @param extraOptions (Opcional) Opções extras de customização
     * @returns Título com options do jsPDF
     */
    criarTituloPagina(text, extraOptions) {
        return Object.assign({ text: text, x: 5, fontSize: this.theme.lgFontSizePDF, fontColor: this.theme.titleFontColor }, extraOptions);
    }
    /**
     * Gera o título da tabela com seus estilos
     * @param text Título da tabela
     * @param extraOptions (Opcional) Opções extras de customização
     * @returns Título com options do jsPDF
     */
    criarTituloTabela(text, extraOptions) {
        return Object.assign({ text: text, fontSize: this.theme.smFontSizePDF, fontColor: this.theme.titleFontColor }, extraOptions);
    }
    /**
     * Gera o título do gráfico com seus estilos
     * @param text Título do gráfico
     * @param extraOptions (Opcional) Opções extras de customização
     * @returns Título com options do jsPDF
     */
    criarTituloGrafico(text) {
        return {
            text: text,
            fontSize: this.theme.smFontSizePDF,
            fontColor: this.theme.titleFontColor,
        };
    }
}
docJSPDF.styleTableBody = {
    overflow: 'linebreak',
    fillColor: '#FFFFFF',
    textColor: '#646e7b',
};
